import React from 'react';
import styled from 'styled-components';
import { ScanOutlined, SearchOutlined, StockOutlined } from '@ant-design/icons';
import { Form } from '@ant-design/compatible';
import { connect } from 'react-redux';
import '@ant-design/compatible/assets/index.css';
import {
  Row,
  Col,
  Spin,
  Button,
  List,
  Tabs,
  Popover,
  Input,
  Table,
  Divider,
  Modal,
  Select,
  Card,
  InputNumber,
  Badge,
  Typography,
  Space,
  Progress,
  Tooltip
} from 'antd';
import { MinusCircleFilled, DeleteFilled } from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import pdfMake from 'pdfmake/build/pdfmake';
import vfsFonts from 'pdfmake/build/vfs_fonts';
import prepDefinition from 'src/components/meta/PdfDefinition';
import { updateRig1, updateRig2 } from 'src/redux/actions/status';
import moment from 'moment';
import NewIcon from 'src/static/new-icon.svg';
import TotalIcon from 'src/static/new-icon.svg';
import SharpIcon from 'src/static/sharp-icon.svg';
import DamagedIcon from 'src/static/damaged-icon.svg';
import LostIcon from 'src/static/lost-icon.svg';
import ToolsIcon from 'src/static/tools-icon.png';
import RigsIcon from 'src/static/rigs-icon.png';
import CostIcon from 'src/static/cost-icon.png';
import PitIcon from 'src/static/pit-icon.png';
import UsersIcon from 'src/static/user-icon.png';
import damagesIcon from 'src/static/damage-icon.png';
import Notify from 'src/components/meta/Notification';
import { withRouter, Link } from 'react-router-dom';

const { Title } = Typography;

const { Column, ColumnGroup } = Table;
const { TextArea } = Input;
const FormItem = Form.Item;
const Option = Select.Option;
const numeral = require('numeral');
const { TabPane } = Tabs;

const StyledTable = styled(Table)`
  .ant-table-thead > tr > th {
    color: #8898aa;
    background: #eef5ff !important;
  }
  .ant-table-tbody > tr > td {
    border-bottom: 1px solid #f0f0f0;
    transition: background 0.3s;

    font-weight: 500;
    color: #525f7f;
    font-size: 15px;
  }
`;
const StyledCard = styled(Card)`
  .ant-card-body {
    height: 5.4em;
    padding: 10px !important;
    padding-top: 10px !important;
    padding-bottom: 3px !important;
    display: flex;
  }
`;
const StyledBadge = styled(Badge)`
  .ant-badge-status-dot {
    height: 0.6em !important;
    width: 0.6em !important;
  }
`;

class Dashboard extends React.Component {
  static defaultProps = {
    error: null,
    member: {},
    loading: false,
    closed: false,
    rejectReason: '',
    size: 'large',
    flag: false
  };
  componentWillMount = () => {
    this.setState({ loading: true });
    this.props
      .findAllStock()
      .then(() => {
        let itemCodes = [];
        this.props.stock.forEach(stock => {
          if (stock.itemCode) {
            itemCodes.push(
              'Part: ' + stock.itemCode + ' - Location: ' + stock.location
            );
          }
        });
        this.setState({ loading: false, itemCodes: itemCodes });
      })
      .catch(e => {
        this.setState({ loading: false });
        Notify('error', e);
      });
    this.props
      .findAllBits()
      .then(() => {
        this.setState({ loading: false });
      })
      .catch(e => {
        this.setState({ loading: false });
        Notify('error', e);
      });
    this.updateSignal = {
      signal: msg => {
        this.props
          .findAllBits()
          .then(() => {
            this.setState({ loading: false });
          })
          .catch(e => {
            this.setState({ loading: false });
            Notify('error', e);
          });
        this.props
          .findAllStock()
          .then(() => {
            let itemCodes = [];
            this.props.stock.forEach(stock => {
              if (stock.itemCode) {
                itemCodes.push(
                  'Part: ' + stock.itemCode + ' - Location: ' + stock.location
                );
              }
            });
            this.setState({ loading: false, itemCodes: itemCodes });
          })
          .catch(e => {
            this.setState({ loading: false });
            Notify('error', e);
          });
      }
    };
    window.pubnub.addListener(this.updateSignal);
    window.addEventListener('resize', this.resizeEvent);
    //if (window.cordova) {
    //  document.addEventListener("backbutton", this.handleBack);
    //}
  };
  handleSubmit = event => {
    event.preventDefault();

    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        if (typeof values.remember === 'undefined') {
          values.remember = false;
        }
        this.signIn(values);
      }
    });
  };

  signIn = values => {
    this.setState({ loading: true });
    this.props
      .signIn(values, this.props.currentLocale)
      .then(() => {
        this.setState({ loading: false });
        this.props.push('/dashboard');
      })
      .catch(e => {
        this.setState({ loading: false });
        Notify('error', window.i18n.translate('Notify3'), e);
      });
  };

  toggleShowPass = () => {
    this.state.passShow === 'password'
      ? this.setState({ passShow: 'text' })
      : this.setState({ passShow: 'password' });
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      passShow: 'password'
    };
  }

  handleLocaleSwitch = locale => {
    this.setState({ loading: true });
    this.props
      .changeLocale(locale)
      .then(() => {
        this.props.form.resetFields();
        this.setState({ loading: false });
        // location.reload();
      })
      .catch(e => {
        console.log(e);
      });
  };
  getColumnSearchProps = dataIndex => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          onClick={() => this.handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: text =>
      text ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) : (
        ''
      )
  });

  renderStatus = (status, color) => {
    return (
      <p style={{ margin: 0 }}>
        <StyledBadge color={color} style={{}} />
        {status}
      </p>
    );
  };

  render() {
    return (
      <div style={{ maxWidth: '90em', margin: 'auto' }}>
        {this.props.user.type === 'admin' ? (
          <Row style={{ marginTop: '1em' }}>
            <Col span={8} style={{ margin: 'auto' }}>
              <StyledCard
                style={{
                  boxShadow: '0px 6px 10px 0px rgba(0, 0, 0, 0.10)',
                  borderRadius: '0.7em',
                  border: 'none',
                  padding: '0em',
                  whiteSpace: 'nowrap',
                  fontFamily: 'Poppins',
                  height: '7em',
                  minWidth: '14em',
                  width: '100%',
                  overflow: 'hidden'
                }}
              >
                <Col span={11}>
                  <img
                    src={SharpIcon}
                    style={{
                      marginTop: 10,
                      marginLeft: 10,
                      top: '-5em',
                      left: '-5em',
                      width: '15em',
                      height: '15em',
                      opacity: 0.3,
                      position: 'absolute'
                    }}
                  />
                </Col>
                <Col span={12}>
                  <span
                    style={{
                      fontWeight: 500,
                      fontSize: 14,
                      color: '#8C8C8C'
                      //marginLeft: -10
                    }}
                  >
                    <p
                      style={{
                        marginTop: 10,
                        marginLeft: -11
                      }}
                    >
                      Total Rigs
                    </p>
                  </span>{' '}
                  <br />
                  <p
                    style={{
                      fontWeight: 900,
                      fontSize: 30,
                      color: '#343434',
                      marginTop: -40,
                      marginBottom: 0,
                      marginLeft: -10
                    }}
                  >
                    {this.props.stock.length}
                  </p>
                  {/*<p
                  style={{
                    fontWeight: 500,
                    color: "#ffa724",
                    marginTop: 9,
                    marginLeft: 30,
                    minWidth: "3em",
                  }}
                >
                  See more
                </p>*/}
                </Col>
              </StyledCard>
            </Col>
            <Col span={8} style={{ margin: 'auto' }}>
              <StyledCard
                style={{
                  boxShadow: '0px 6px 10px 0px rgba(0, 0, 0, 0.10)',
                  borderRadius: '0.7em',
                  border: 'none',
                  padding: '0em',
                  whiteSpace: 'nowrap',
                  fontFamily: 'Poppins',
                  height: '7em',
                  minWidth: '14em',
                  width: '100%',
                  overflow: 'hidden'
                }}
              >
                <Col span={11}>
                  <img
                    src={TotalIcon}
                    style={{
                      marginTop: 10,
                      marginLeft: 10,
                      top: '-5em',
                      left: '-5em',
                      width: '15em',
                      height: '15em',
                      opacity: 0.3,
                      position: 'absolute',

                      transform: 'rotate(-35deg)',
                      filter: 'grayscale(90%)'
                    }}
                  />
                </Col>
                <Col span={12}>
                  <span
                    style={{
                      fontWeight: 500,
                      fontSize: 14,
                      color: '#8C8C8C'
                      //marginLeft: -10
                    }}
                  >
                    <p
                      style={{
                        marginTop: 10,
                        marginLeft: -11
                      }}
                    >
                      Total Tools
                    </p>
                  </span>{' '}
                  <br />
                  <p
                    style={{
                      fontWeight: 900,
                      fontSize: 30,
                      color: '#343434',
                      marginTop: -40,
                      marginBottom: 0,
                      marginLeft: -10
                    }}
                  >
                    {this.props.bits.length}
                  </p>
                </Col>
              </StyledCard>
            </Col>{' '}
          </Row>
        ) : null}
        <Row
          type="flex"
          justify="start"
          align="middle"
          style={{
            borderBottom: '1px solid #DDDDDD',
            maxWidth: '70em',
            margin: 'auto',
            marginTop: '4em'
          }}
        >
          <Col
            xs={12}
            md={12}
            style={{ marginLeft: '-0.8em', marginTop: '-1.6em' }}
          >
            <span
              style={{
                fontWeight: 500,
                fontSize: 26,
                color: '#FF9D66',
                marginLeft: 10,
                fontFamily: 'Roboto'
              }}
            >
              Quick Select
            </span>{' '}
            <br />
          </Col>
          <Col
            xs={12}
            md={12}
            style={{
              marginTop: '0.8em',
              textAlign: 'right'
            }}
          >
            <Col span={18} style={{ float: 'right', whiteSpace: 'nowrap' }}>
              <p
                style={{
                  fontWeight: 500,
                  fontSize: 26,
                  color: 'lightgrey',
                  marginLeft: 0,
                  fontFamily: 'Roboto'
                }}
              />
            </Col>
            <br />
          </Col>
        </Row>
        <Row
          style={{
            maxWidth: '70em',
            margin: 'auto',
            marginTop: 20
          }}
        >
          {this.props.user.type === 'admin' ? (
            <Col
              span={11}
              style={{ margin: 'auto', marginTop: '1.5em', marginLeft: 0 }}
            >
              <Link to="/admin/bitmanagement">
                <StyledCard
                  style={{
                    border: '1px solid #EC8144',
                    borderRadius: '1em',
                    padding: '0em',
                    whiteSpace: 'nowrap',
                    backgroundColor: 'white',
                    fontFamily: 'Poppins',
                    height: '4.5em',
                    textAlign: 'center',
                    width: '80%',
                    margin: 'auto'
                  }}
                >
                  <p
                    style={{
                      margin: 'auto',
                      fontWeight: 500,
                      fontSize: 20,
                      color: '#EC8144',
                      marginTop: 5
                    }}
                  >
                    <img
                      src={ToolsIcon}
                      style={{
                        width: '1em',
                        marginTop: '-0.3em',
                        marginRight: '0.2em'
                      }}
                    />{' '}
                    All Tools
                  </p>
                </StyledCard>
              </Link>
            </Col>
          ) : null}
          {this.props.user.type === 'admin' ? <Col span={2} /> : null}
          <Col
            span={11}
            style={{ margin: 'auto', marginTop: '1.5em', marginLeft: 0 }}
          >
            <Link to="/admin/stock">
              <StyledCard
                style={{
                  border: '1px solid #EC8144',
                  borderRadius: '1em',
                  padding: '0em',
                  whiteSpace: 'nowrap',
                  backgroundColor: 'white',
                  fontFamily: 'Poppins',
                  height: '4.5em',
                  textAlign: 'center',
                  width: '80%',
                  margin: 'auto'
                }}
              >
                <p
                  style={{
                    margin: 'auto',
                    fontWeight: 500,
                    fontSize: 20,
                    color: '#EC8144',
                    marginTop: 5
                  }}
                >
                  <img
                    src={RigsIcon}
                    style={{
                      width: '1.5em',
                      marginTop: '-0.3em'
                    }}
                  />{' '}
                  Rig Management
                </p>
              </StyledCard>
            </Link>
          </Col>

          <Col
            span={11}
            style={{ margin: 'auto', marginTop: '1.5em', marginLeft: 0 }}
          >
            <Link to="/admin/pexrequests">
              <StyledCard
                style={{
                  border: '1px solid #EC8144',
                  borderRadius: '1em',
                  padding: '0em',
                  whiteSpace: 'nowrap',
                  backgroundColor: 'white',
                  fontFamily: 'Poppins',
                  height: '4.5em',
                  textAlign: 'center',
                  width: '80%',
                  margin: 'auto'
                }}
              >
                <p
                  style={{
                    margin: 'auto',
                    fontWeight: 500,
                    fontSize: 20,
                    color: '#EC8144',
                    marginTop: 5
                  }}
                >
                  <img
                    src={CostIcon}
                    style={{
                      width: '1em',
                      marginTop: '-0.3em',
                      marginRight: '0.2em'
                    }}
                  />{' '}
                  Costs
                </p>
              </StyledCard>
            </Link>
          </Col>
          <Col span={2} />
          {this.props.user.type === 'admin' ? (
            <Col
              span={11}
              style={{ margin: 'auto', marginTop: '1.5em', marginLeft: 0 }}
            >
              <Link to="/admin/users">
                <StyledCard
                  style={{
                    border: '1px solid #EC8144',
                    borderRadius: '1em',
                    padding: '0em',
                    whiteSpace: 'nowrap',
                    backgroundColor: 'white',
                    fontFamily: 'Poppins',
                    height: '4.5em',
                    textAlign: 'center',
                    width: '80%',
                    margin: 'auto'
                  }}
                >
                  <p
                    style={{
                      margin: 'auto',
                      fontWeight: 500,
                      fontSize: 20,
                      color: '#EC8144',
                      marginTop: 5
                    }}
                  >
                    <img
                      src={UsersIcon}
                      style={{
                        width: '1em',
                        marginTop: '-0.3em',
                        marginRight: '0.2em'
                      }}
                    />{' '}
                    All Users
                  </p>
                </StyledCard>
              </Link>
            </Col>
          ) : null}

          <Col
            span={11}
            style={{ margin: 'auto', marginTop: '1.5em', marginLeft: 0 }}
          >
            <Link to="/admin/pexunit">
              <StyledCard
                style={{
                  border: '1px solid #EC8144',
                  borderRadius: '1em',
                  padding: '0em',
                  whiteSpace: 'nowrap',
                  backgroundColor: 'white',
                  fontFamily: 'Poppins',
                  height: '4.5em',
                  textAlign: 'center',
                  width: '80%',
                  margin: 'auto'
                }}
              >
                <p
                  style={{
                    margin: 'auto',
                    fontWeight: 500,
                    fontSize: 20,
                    color: '#EC8144',
                    marginTop: 5
                  }}
                >
                  <img
                    src={damagesIcon}
                    style={{
                      width: '1em',
                      marginTop: '-0.3em',
                      marginRight: '0.2em'
                    }}
                  />{' '}
                  Damages
                </p>
              </StyledCard>
            </Link>
          </Col>
        </Row>
        {/* <Row
          style={{
            marginTop: '1em'
          }}
        >
          <Col span={24}>
            <Spin spinning={this.state.loading}>
              <Row>
                <Col span={24}>
                  <Card
                    bordered={false}
                    style={{
                      marginTop: '0.5em',
                      borderRadius: '1em',
                      boxShadow: '0px 6px 15px 0px rgba(0, 0, 0, 0.08)'
                    }}
                    title={
                      <Title
                        level={4}
                        style={{
                          fontWeight: 700,
                          whiteSpace: 'nowrap',
                          marginBottom: '0em'
                        }}
                      >
                        Tools Logs
                      </Title>
                    }
                  >
                    <StyledTable
                      bordered={false}
                      dataSource={this.props.bits}
                      rowKey="_id"
                      size="middle"
                      pagination={
                        false
                       
                      }
                      style={{
                        borderRadius: '1.5em',

                        minWidth: '15em'
                    
                      }}
                    >
                      <Column
            
                        title="Serial"
                        dataIndex="serial"
                        key="serial"
                      />
                      {window.innerWidth > 420 ? (
                        <Column
                
                          title="Tool Type"
                          dataIndex="size"
                          key="size"
                        />
                      ) : null}
                      {window.innerWidth > 420 ? (
                        <Column
                     
                          title="Description"
                          dataIndex="description"
                          key="description"
                        />
                      ) : null}
                      {window.innerWidth > 420 ? (
                        <Column
                    
                          title="Current Rig"
                          dataIndex="currentRig"
                          key="currentRig"
                        />
                      ) : null}
               
                      {window.innerWidth > 420 ? (
                        <Column
                        
                          title="Status"
                          dataIndex="status"
                          key="status"
                          render={status => {
                            switch (status) {
                              case 'New':
                                return this.renderStatus('New', '#4BED5B');
                              case 'Used':
                                return this.renderStatus('Used', '#EE4C4C');
                              case 'Out':
                                return this.renderStatus('Out', '#FF8F28');
                              case 'Sharp':
                                return this.renderStatus('Sharp', '#EDAC4B');
                              case 'Lost':
                                return this.renderStatus('Lost', '#D4D4D4');
                              case 'Damaged':
                                return this.renderStatus('Damaged', '#EE4C4C');
                              default:
                                return this.renderStatus(
                                  'No Status',
                                  'lightgrey'
                                );
                            }
                          }}
                        />
                      ) : null}
                    </StyledTable>
                  </Card>
                </Col>
              </Row>
            </Spin>
          </Col>
        </Row> */}
      </div>
    );
  }
}

export default Dashboard;
